module.exports = __webpack_public_path__ + "img/pramita_kotak.5304a156.png";